import { render } from "./ourTeam.vue?vue&type=template&id=0471a68f&scoped=true"
import script from "./ourTeam.vue?vue&type=script&lang=js"
export * from "./ourTeam.vue?vue&type=script&lang=js"

import "./ourTeam.vue?vue&type=style&index=0&id=0471a68f&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0471a68f"]])

export default __exports__